var _rect, _rect2, _rect3, _circle, _path, _path2, _path3, _path4, _circle2, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path6, _path7, _path8, _rect14, _rect15, _circle12, _circle13, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1931,
    height: 976,
    viewBox: "0 0 1931 976",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 306.304,
    y: 73.4043,
    width: 39.5155,
    height: 39.5155,
    rx: 8,
    transform: "rotate(43.8536 306.304 73.4043)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 402.199,
    y: 96.248,
    width: 39.5155,
    height: 39.5155,
    rx: 8,
    transform: "rotate(-18.6187 402.199 96.248)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 510.78,
    y: 131.517,
    width: 18.4648,
    height: 18.4648,
    rx: 8,
    transform: "rotate(27.5152 510.78 131.517)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1790.54,
    cy: 765.349,
    r: 26.7266,
    fill: "#FFD600",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.113 261.038C602.227 263.942 625.744 285.113 649.862 304.984C678.07 328.226 716.471 347.358 720.03 383.734C723.727 421.516 694.906 453.889 666.945 479.567C640.349 503.991 607.094 523.528 571.113 520.493C537.164 517.63 513.764 489.252 490.189 464.658C467.356 440.84 442.642 416.624 440.016 383.734C437.215 348.637 450.442 312.829 476.148 288.77C501.178 265.344 536.979 257.852 571.113 261.038Z",
    stroke: "#FFD600",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1709.32 484.816C1733.02 487.028 1750.93 503.153 1769.3 518.289C1790.79 535.991 1820.04 550.564 1822.75 578.27C1825.56 607.047 1803.61 631.704 1782.31 651.262C1762.06 669.866 1736.73 684.746 1709.32 682.435C1683.46 680.254 1665.64 658.64 1647.68 639.907C1630.29 621.765 1611.47 603.321 1609.47 578.27C1607.34 551.538 1617.41 524.264 1636.99 505.939C1656.05 488.096 1683.32 482.389 1709.32 484.816Z",
    stroke: "#FFD600",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1703.91 495.512C1726.33 497.604 1743.27 512.858 1760.65 527.175C1780.97 543.92 1808.64 557.705 1811.2 583.914C1813.86 611.135 1793.1 634.459 1772.95 652.96C1753.79 670.558 1729.83 684.634 1703.91 682.447C1679.45 680.384 1662.59 659.939 1645.6 642.219C1629.15 625.058 1611.35 607.61 1609.45 583.914C1607.44 558.627 1616.97 532.827 1635.49 515.493C1653.52 498.615 1679.31 493.216 1703.91 495.512Z",
    stroke: "#FFD600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1713.24 513.22C1732.58 515.025 1747.2 528.183 1762.19 540.533C1779.72 554.978 1803.58 566.868 1805.79 589.476C1808.09 612.957 1790.18 633.077 1772.8 649.036C1756.27 664.215 1735.61 676.357 1713.24 674.471C1692.14 672.692 1677.6 655.055 1662.95 639.77C1648.76 624.967 1633.4 609.917 1631.77 589.476C1630.03 567.663 1638.25 545.409 1654.22 530.456C1669.78 515.897 1692.03 511.24 1713.24 513.22Z",
    stroke: "#FFD600"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.756,
    cy: 425.135,
    r: 90.7439,
    fill: "#FFD600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1296.11 368.106C1305.23 353.134 1316.07 336.704 1333.37 333.878C1349.74 331.204 1362.57 345.741 1376.33 355.004C1388.05 362.889 1401.77 369.392 1406.11 382.833C1410.51 396.489 1405.65 411.122 1398.44 423.525C1391.46 435.505 1380.63 444.276 1367.6 449.01C1353.63 454.086 1338.82 455.011 1324.72 450.306C1307.21 444.466 1286.93 437.507 1280.86 420.075C1274.69 402.35 1286.35 384.134 1296.11 368.106Z",
    fill: "#FFD600"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.755,
    cy: 407.423,
    r: 124.47,
    fill: "#FFD600",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 423.21,
    r: 90.7439,
    fill: "#FFD600",
    fillOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1875.37,
    cy: 733.605,
    r: 15.8987,
    fill: "#FFD600"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1797.17,
    cy: 760.179,
    r: 39.7114,
    fill: "#FFD600",
    fillOpacity: 0.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1802.14,
    cy: 752.364,
    r: 39.7114,
    stroke: "#FFD600"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1780.46,
    cy: 778.196,
    r: 8.2749,
    fill: "#FFD600",
    fillOpacity: 0.35
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1718.77,
    cy: 633.218,
    r: 12.6394,
    fill: "#FFD600"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1423.88,
    cy: 764.024,
    r: 45.3708,
    fill: "#FFD600"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.705,
    cy: 589.112,
    r: 54.6589,
    fill: "#FFD600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1188.03,
    y: 513.705,
    width: 93.9312,
    height: 93.9312,
    rx: 8,
    transform: "rotate(139.433 1188.03 513.705)",
    fill: "#FFD600"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 982.413,
    y: 709.531,
    width: 45.1029,
    height: 45.1029,
    rx: 8,
    transform: "rotate(139.433 982.413 709.531)",
    fill: "#FFD600"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 986.283,
    y: 720.171,
    width: 45.1029,
    height: 45.1029,
    rx: 8,
    transform: "rotate(139.433 986.283 720.171)",
    fill: "#FFD600",
    fillOpacity: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1640.62,
    y: 325.989,
    width: 58.1179,
    height: 58.1179,
    rx: 8,
    transform: "rotate(43.8536 1640.62 325.989)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1662.32,
    y: 355.027,
    width: 17.3919,
    height: 17.3919,
    transform: "rotate(43.8536 1662.32 355.027)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1715.93,
    y: 353.534,
    width: 13.1539,
    height: 13.1539,
    transform: "rotate(43.8536 1715.93 353.534)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1649.45,
    y: 325.167,
    width: 58.1179,
    height: 58.1179,
    transform: "rotate(43.8536 1649.45 325.167)",
    stroke: "#FFD600"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1891.71,
    y: 387.055,
    width: 38.654,
    height: 38.654,
    rx: 8,
    transform: "rotate(2.91838 1891.71 387.055)",
    fill: "#FFD600",
    fillOpacity: 0.44
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 497.984,
    y: 501.631,
    width: 40.3531,
    height: 40.3531,
    rx: 8,
    transform: "rotate(63.6319 497.984 501.631)",
    fill: "#FFD600",
    fillOpacity: 0.64
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 496.164,
    y: 505.604,
    width: 42.8838,
    height: 42.8838,
    rx: 8,
    transform: "rotate(63.6319 496.164 505.604)",
    fill: "#FFD600",
    fillOpacity: 0.64
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.309 741.264C148.762 742.021 165.444 762.062 181.281 779.378C196.141 795.626 209.089 813.448 211.359 835.349C213.896 859.826 211.982 887.228 194.225 904.265C176.659 921.12 149.586 919.731 125.309 917.915C103.293 916.268 82.1681 909.692 65.9858 894.673C49.1432 879.041 36.4254 858.328 36.3514 835.349C36.2772 812.31 49.7739 792.384 65.6025 775.643C82.0049 758.295 101.447 740.493 125.309 741.264Z",
    stroke: "#FFD600",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.15 617.83C227.166 619.348 260.608 659.524 292.355 694.236C322.144 726.807 348.101 762.536 352.652 806.44C357.738 855.508 353.899 910.44 318.304 944.594C283.089 978.383 228.818 975.597 180.15 971.957C136.014 968.655 93.6663 955.473 61.2261 925.364C27.4624 894.027 1.9673 852.506 1.81897 806.44C1.67025 760.255 28.7266 720.308 60.4578 686.748C93.3391 651.971 132.315 616.286 180.15 617.83Z",
    stroke: "#FFD600",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.086 807.661C139.396 808.123 149.575 820.351 159.238 830.916C168.305 840.83 176.206 851.705 177.591 865.068C179.139 880.003 177.97 896.723 167.136 907.118C156.418 917.403 139.899 916.555 125.086 915.447C111.652 914.442 98.763 910.43 88.8891 901.265C78.6124 891.727 70.8525 879.089 70.8073 865.068C70.762 851.011 78.9972 838.852 88.6553 828.637C98.6634 818.052 110.527 807.191 125.086 807.661Z",
    stroke: "#FFD600"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 439.865,
    y: 513.579,
    width: 58.1179,
    height: 58.1179,
    rx: 8,
    transform: "rotate(63.6319 439.865 513.579)",
    fill: "#FFD600",
    fillOpacity: 0.64
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 436.018,
    y: 520.805,
    width: 64.5912,
    height: 64.5912,
    rx: 8,
    transform: "rotate(63.6319 436.018 520.805)",
    fill: "#FFD600",
    fillOpacity: 0.64
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.651,
    cy: 73.4041,
    r: 72.0491,
    stroke: "#FFD600",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.651,
    cy: 83.6321,
    r: 55.3879,
    stroke: "#FFD600",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 305.579,
    y: 85.7085,
    width: 31.0732,
    height: 31.0732,
    transform: "rotate(19.8875 305.579 85.7085)",
    fill: "#FFD600"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 114.984,
    y: 841.968,
    width: 31.0732,
    height: 31.0732,
    transform: "rotate(19.8875 114.984 841.968)",
    fill: "#FFD600"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 343.543,
    y: 80.2749,
    width: 15.9736,
    height: 15.9736,
    transform: "rotate(19.8875 343.543 80.2749)",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.30e0986cd9db16c198224b919fb7e0c7.svg";
export { ForwardRef as ReactComponent };